import React, { useMemo } from "react";
import { Menu, Sidebar, Grid } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
// update SOFC : Main/PSM 구분
import { hideSidebarMenu } from "../../actions/navActions";

const SidebarMenu = ({ routes }) => {
  const dispatch = useDispatch();
  const sidebarVisible = useSelector((state) => state.nav.sidebarMenuVisible);
  const { pathname } = useLocation();

  // update SOFC : Main/PSM 구분
  const operateVersion = useSelector((state) => state.header.operateVersion);
  const sameMenuItemClick = useSelector(
    (state) => state.header.sameMenuItemClick,
  );

  const headers = useMemo(
    () =>
      routes.reduce((acc, { page }) => {
        if (!page.section) {
          return acc;
        }
        const last = acc.slice(-1)[0]; // 배열의 가장 마지막
        if (last && last.name === page.section) {
          last.items.push(page);
          return acc;
        }
        acc.push({ name: page.section, items: [page] });

        return acc;
      }, []),
    [routes],
  );

  // update SOFC : Main/PSM 구분
  const handleHeaderMenuClick = (value) => {
    // update SOFC by sumin 240301 : sidebar hide 조건 추가
    if (value !== null) {
      if (value.target.tagName !== "A") {
        dispatch(hideSidebarMenu());
      }
      if (sameMenuItemClick) {
        // if click menuitem -> sidebar Close
        dispatch(hideSidebarMenu());
      }
    }
  };

  const handleRoutesClick = () => {
    dispatch(hideSidebarMenu());
  };

  return (
    <Sidebar
      inverted
      vertical
      animation="overlay" // animation='push' : 전체 화면 밀리는 기능 추가시 해당 option 사용
      as={Menu}
      onHide={handleHeaderMenuClick}
      visible={sidebarVisible}
    >
      <div>
        <Grid inverted padded>
          <Grid.Row style={{ backgroundColor: "#3d3e3f" }}>
            {" "}
            {/**6389b0, // update SOFC : Main/PSM 구분  */}
            <Menu.Item style={{ paddingTop: "0px", paddingBottom: "0px" }}>
              {" "}
              {operateVersion.slice(1, operateVersion.length)}
            </Menu.Item>
          </Grid.Row>
        </Grid>
      </div>

      {headers.map((header) =>
        header.name.includes(operateVersion) ? (
          <Menu.Item key={header.name}>
            {header.name.substring(0, header.name.indexOf("_"))}{" "}
            {/** SYSTEM OVERVIEW */}
            <Menu.Menu>
              <p />
              {header.items.map((item) => (
                <Menu.Item
                  as={Link}
                  to={item.path}
                  active={pathname === item.path}
                  key={item.name}
                  name={item.name}
                  onClick={handleRoutesClick}
                />
              ))}
            </Menu.Menu>
          </Menu.Item>
        ) : (
          ""
        ),
      )}
    </Sidebar>
  );
};

export default SidebarMenu;
